<template>
  <b-modal id="modalConfirmMessages" centered hide-header size="sm" @ok="ok">
    <div class="d-block text-center">
      <Icon name="grAlertTriangle" width="36" class="mb-3"/>
    </div>
    <div>
      <template v-if="confirmMessages.length > 1">
        <div v-for="(item, index) in confirmMessages" :key="index">
          <h6>{{item.pica_service_name}}</h6>
          <div v-html="item.message"></div>
          <hr>
        </div>
      </template>
      <template v-else>
        <div class="text-center" v-html="confirmMessages[0].message"></div>
      </template>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 ml-sm-2 mb-2 mb-sm-0">
            <b-button variant="primary" block @click="ok()">
              {{ $t('modal_confirm_messages.btn_ok') }}
            </b-button>
          </div>
          <div class="flex-grow-1 order-sm-0 mr-sm-2">
            <b-button variant="light" block @click="cancel()">
              {{ $t('modal_confirm_messages.btn_cancel') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>


import {mapGetters} from "vuex";

export default {
  name: 'ModalConfirmMessages',
  data() {
    return {

    }
  },
  props: {

  },
  computed: {
    ...mapGetters('cartDigitalItems', [
      'confirmMessages',
    ]),
  },
  methods: {
    open() {
      this.$bvModal.show('modalConfirmMessages')
    },
    ok() {
      this.$emit('ok')
      this.$bvModal.hide('modalConfirmMessages')
    },
  }

}
</script>
